import { Routes, RouterModule } from "@angular/router";

import { DistrictLookupComponent } from "../schoolsearch/district-lookup/district-lookup.component";
import { AuthguardService } from "../master/services";

export const SchoolSearchRoutes: Routes = [
	// { path: '', redirectTo: '/siteadmin/district', pathMatch: 'full' },
	// { path: 'districtlookup', data: { title: 'District Lookup' }, component: DistrictLookupComponent },

	{
		path: "",
		data: { title: "School Search" },
		component: DistrictLookupComponent,
		// canActivate: [AuthguardService],
	},
];
